import { render } from "./TempiDiAttesa.vue?vue&type=template&id=29590b1f&scoped=true"
import script from "./TempiDiAttesa.vue?vue&type=script&lang=js"
export * from "./TempiDiAttesa.vue?vue&type=script&lang=js"

import "./TempiDiAttesa.vue?vue&type=style&index=0&id=29590b1f&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29590b1f"]])

export default __exports__